










































import {Component, Prop, Ref} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "../../mixins/component-base.mixin";
import storage from "@/services/local-storage.service";
import moment from "moment";
import {PodsetnikOsobe, PodsetnikVozila} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";
import {formatDate} from "@/utils/formatters";
import PodsetnikOsobeDialog from "@/views/Podsetnici/PodsetnikOsobeDialog.vue";
import CalendarComponent from "@/components/CalendarComponent2.vue";
import {sortByDate} from "@/utils/functions";

declare const $: any;

@Component({components: {'mf-podsetnik-osobe-dialog': PodsetnikOsobeDialog, 'mf-calendar' : CalendarComponent}})
export default class PregledPodsetnikaOsoba extends mixins(ComponentBaseMixin) {
    @Prop({default: undefined}) id!: number;

    podsetniciOsobe = [];
    view: any = '';
    dialogVisible = false;
    columns = [];
    tableOptions = {
        pagination: true,
        search: true,
        onClickRow: row => this.onClickRow(row),
        rowStyle: this.rowStyle,
        detailView: true,
        detailFormatter: this.renderDetails
    };
    podsetnikOsobeRow = PodsetnikOsobe.fromJS({ukljucen: true});
    isBusy = false;
    @Ref('calendar') calendar: CalendarComponent;
    async created() {
        this.isBusy = true;
        try {
            if (!this.id) {
                this.podsetniciOsobe = await this.loadData(() => dataProxy.vratiPodsetnikeOsoba())();
            } else {
                this.podsetniciOsobe = await this.loadData(() => dataProxy.vratiPodsetnikeOsobe(this.id))();
            }
            this.columns = [
                {field: 'osoba', title: this.$i18n.t('osoba'), width: 200, sortable: true},
                {field: 'datum', title: this.$i18n.t('datum'), width: 110, formatter: value => formatDate(value), sortable: true,
                    sorter: (f1, f2) => sortByDate(f1, f2)},
                {
                    field: 'upozoriPre', title: this.$i18n.t('upozoriPre'), width: 110,
                    formatter: this.upozoriPreFormatter,
                    sortable: true
                },
                {field: 'razlika', title: this.$i18n.t('razlika'), width: 110, formatter: this.razlikaFormatter, sortable: true},
                {field: 'opis', title: this.$i18n.t('opis'), width: 280, sortable: true},
                {
                    field: 'ukljucen', title: this.$i18n.t('ukljucen'), width: 90,
                    formatter: value => value ? this.$i18n.t('da') : this.$i18n.t('ne'),
                    sortable: true
                },
                {
                    field: 'id', cellStyle: this.cellStyle, align: 'center', width: 30,
                    formatter: (value) => `<i class="fa fa-trash text-danger btn-delete" data-id="${value}"></i>`
                }
            ];
            this.isBusy = false;
        } catch (err) {
            this.isBusy = false;
        }

        if (storage.get('podsetnikOsobaView') !== null) {
            if (storage.get('podsetnikOsobaView') === 'CALENDAR_VIEW') {
                setTimeout(() => this.view = storage.get('podsetnikOsobaView'), 1000);
            } else {
                this.view = storage.get('podsetnikOsobaView');
            }
        } else {
            this.view = 'TABLE_VIEW';
        }
    }

    async eventLoader() {
        let podsetnici;
        if (this.id) {
            podsetnici = await dataProxy.vratiPodsetnikeOsobe(this.id);
        } else {
            podsetnici = await dataProxy.vratiPodsetnikeOsoba();
        }
        return podsetnici.map(podsetnik => ({
            title: this.id ? podsetnik.opis : `${podsetnik.osoba}\n${podsetnik.opis}`,
            start: podsetnik.datum,
            allDay: true,
            extendedProps: podsetnik
        }))
    }

    eventStyler(event) {
        event.el.style.color = 'white';
        event.el.style.borderColor = 'white';

        if (!event.event.extendedProps.ukljucen) {
            event.el.style.borderColor = '#E5E7E9';
            event.el.style.backgroundColor = '#E5E7E9';
            return;
        }

        let rowDate = moment(event.event.start);
        let todaysDate = moment();
        let result = rowDate.diff(todaysDate, 'days');
        if (todaysDate.isAfter(rowDate)) {
            event.el.style.backgroundColor = '#f7531f';
            event.el.style.borderColor = '#f7531f';
        } else if (result < event.event.extendedProps.upozoriPre) {
            event.el.style.backgroundColor = '#ff9800';
            event.el.style.borderColor = '#ff9800';
        } else {
            event.el.style.borderColor = '#348cd4';
        }
    }

    eventClicked(podsetnik: PodsetnikOsobe) {
        this.podsetnikOsobeRow = PodsetnikOsobe.fromJS(podsetnik);
        this.dialogVisible = true;
    }

    dateClicked(date: Date) {
        this.podsetnikOsobeRow = PodsetnikOsobe.fromJS({
            ukljucen: true,
            datum: date,
            osobaId: this.id,
            primaoci: []
        });
        this.dialogVisible = true;
    }

    async osveziTabeluPodsetnici() {
        if (!this.id) {
            this.podsetniciOsobe = await this.loadData(() => dataProxy.vratiPodsetnikeOsoba())();
        } else {
            this.podsetniciOsobe = await this.loadData(() => dataProxy.vratiPodsetnikeOsobe(this.id))();
        }
        if (this.calendar) {
            this.calendar.reload();
        }
    }

    setView(view: string) {
        this.view = view;
        storage.add('podsetnikOsobaView', this.view);
        if (this.view === 'TABLE_VIEW') {
            this.osveziTabeluPodsetnici();
        }
    }

    razlikaFormatter(value) {
        return `${value} ${this.$i18n.t('dana')}`
    }

    upozoriPreFormatter(value, row) {
        return `${row.upozoriPre} ${row.upozoriPre > 1 ? this.$i18n.t('danaUpozoriPre') : this.$i18n.t('danUpozoriPre')}`
    }

    onClickRow(row) {
        this.dialogVisible = true;
        this.podsetnikOsobeRow = {...row};
    }

    rowStyle(row, index) {
        if (!row.ukljucen) {
            return {'css' : {'color' : '#b3b4b6'}}
        }
        let rowDate = moment(row.datum);
        let todaysDate = moment();
        let result = rowDate.diff(todaysDate, 'days');
        if (todaysDate.isAfter(rowDate)) {
            return {'css' : {'color' : '#f7531f'}}
        } else if (result < row.upozoriPre) {
            return {'css' : {'color' : '#ff9800'}}
        } else {
            return {'css' : {'color' : '#348cd4'}}
        }
    }

    cellStyle(value, row, index) {
        return {
            classes: 'text-nowrap',
            css: {"color": "white"}
        };
    }

    renderDetails(ix, podsetnikVozila: PodsetnikVozila, element) {
        const detailsTableId = `detailsTable_${ix}`;
        const $detailsTable = $(`<table class="${detailsTableId}"></table>`).bootstrapTable({
            columns: [
                {field: 'display', title: this.$i18n.t('primaoc'), formatter: value => value ? value : ''},
                {field: 'ukljucen', title: this.$i18n.t('ukljucen'), width: 100,
                    formatter: value => value ? this.$i18n.t('da') : this.$i18n.t('ne')}
            ],
            data: podsetnikVozila.primaoci
        });
        $detailsTable.appendTo(element);
    }

    onPostBody() {
        $("i.btn-delete").on('click', async e => {
            const id = $(e.currentTarget).data('id');
            if (id) {
                e.stopPropagation();
                const da = await this.confirmationNeeded('da li zelite da obrisete podsetnik');
                if (da) {
                    this.podsetniciOsobe = this.podsetniciOsobe.filter(x => x.id != id);
                    await this.deleteData(() => dataProxy.obrisiPodsetnik(id))();
                }
            }
        });
    }
}
